import React, { useState } from "react";
import MetricsStrip from "./MetricsStrip";
import SalesFunnel from "./SalesFunnel";
import PipelineTable from "./PipelineTable";
import RepLeaderboard from "./RepLeaderboard";

const TABS = [
  { id: "overview", label: "Overview", icon: "LayoutDashboard" },
  { id: "funnel", label: "Funnel", icon: "Filter" },
  { id: "pipeline", label: "Pipeline", icon: "List" },
  { id: "team", label: "Team", icon: "Users" },
];

export default function MobileTabView({ metrics, funnel, pipelineRows, leaderboard, onUpdateStage, onExport }) {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <div className="flex flex-col gap-4">
      {/* Tab bar */}
      <div className="flex overflow-x-auto border-b" style={{ borderColor: "var(--color-border)" }}>
        {TABS?.map((tab) => (
          <button
            key={tab?.id}
            onClick={() => setActiveTab(tab?.id)}
            className="flex-shrink-0 px-4 py-3 text-sm font-medium font-caption transition-colors relative"
            style={{
              color: activeTab === tab?.id ? "var(--color-primary)" : "var(--color-text-secondary)",
              borderBottom: activeTab === tab?.id ? "2px solid var(--color-primary)" : "2px solid transparent",
              marginBottom: -1,
            }}
          >
            {tab?.label}
          </button>
        ))}
      </div>
      {/* Tab content */}
      <div>
        {activeTab === "overview" && <MetricsStrip metrics={metrics} />}
        {activeTab === "funnel" && <SalesFunnel stages={funnel} />}
        {activeTab === "pipeline" && (
          <PipelineTable rows={pipelineRows} onUpdateStage={onUpdateStage} onExport={onExport} />
        )}
        {activeTab === "team" && <RepLeaderboard reps={leaderboard} />}
      </div>
    </div>
  );
}